import React, {useState} from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {
    FileFormPropsCallback,
    XLSXError,
    XlsxMultipleFilesForm,
} from 'components/common/XlsxMultipleFilesForm';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';
import {Spinner} from 'components/ui-kit/Spinner';
import {
    data$,
    dataChanged,
    isModalOpen$,
    isModalOpenChanged,
    uploadDataApiV2Fx,
} from 'models/registries/gtinsGrid/upload';

import {ButtonsContainer, SpinnerLayer} from './styled';

export const GtinsUploadList = () => {
    const {t} = useTranslation();
    const data = useStore(data$);
    const isModalOpen = useStore(isModalOpen$);
    const [errorsList, setErrorsList] = useState<XLSXError[]>([]);
    const [loading, setLoading] = useState(false);

    const handleClosed = () => {
        isModalOpenChanged(false);
        setErrorsList([]);
    };

    const handleFileChanged = ({data}: FileFormPropsCallback) => {
        dataChanged(data);
        setErrorsList([]);
    };

    const onSubmit = async () => {
        try {
            setLoading(true);
            setErrorsList([]);
            if (!data?.length) return;
            await uploadDataApiV2Fx(data);
        } catch (error) {
            const list = (error as any).fullErrorsList;
            if (!Array.isArray(list)) return;
            setErrorsList(list as XLSXError[]);
        } finally {
            setLoading(false);
        }
    };

    const ModalFooter = (
        <ButtonsContainer>
            <Button variant={ButtonVariant.Outline} onClick={handleClosed}>
                {t('components.modal.Close')}
            </Button>
            <Button disabled={!data || data.length === 0 || loading} onClick={onSubmit}>
                {t('components.form.Submit')}
            </Button>
        </ButtonsContainer>
    );

    return (
        <Modal
            show={isModalOpen}
            onClose={handleClosed}
            title={t('pages.registries.uploadGtinTitle')}
            footer={ModalFooter}
            modalWidth={0}
        >
            <XlsxMultipleFilesForm
                onChange={handleFileChanged}
                errors={errorsList}
                serverValidate
            />
            {loading && (
                <SpinnerLayer>
                    <Spinner />
                </SpinnerLayer>
            )}
        </Modal>
    );
};
